import moment from "moment";

export function formatDate(date, showTime = false, noTimezone = false) {
  if (!moment(date).isValid()) return "";
  let formattedDate = moment(date);
  if (noTimezone) {
    formattedDate = formattedDate.utc();
  }
  return formattedDate.format("Do MMM YYYY" + (showTime ? " - hh:mm A" : ""));
}

// Date + 24h time (e.g. "5th Jul 2026 - 14:30"). formatDate's own `showTime` flag
// renders 12h "hh:mm A", so this doesn't just wrap it — it applies the same
// falsy/invalid-date handling with an explicit 24h format instead.
export function formatDateTime(date) {
  if (!moment(date).isValid()) return "";
  return moment(date).format("Do MMM YYYY - HH:mm");
}

let mapThumbs = {};
export function getCachedImg(hrCode) {
  if (mapThumbs[hrCode] !== undefined) {
    return mapThumbs[hrCode];
  }
  return null;
}

export function cacheImg(hrCode, blob) {
  mapThumbs[hrCode] = blob;
}
